export enum FeaturedImagePosition {
  STATIC = 'static',
  ABSOLUTE = 'absolute',
}
